import actions from "./actions";

const initialState = {
  error: null,
  loading: false,
  plans: [],
  planLinkPrices: [],
  total: 0,
  plan: null,
  apiPlanId: null,
  listUser: [],
  syncPlanStatus: [],
  loadingSyncStatus: false,
  crawlAllLoading: false,
  uploadMultiple: false,
  openSaleStatus: false,
  stopSellingStatus: false,
};

export default function crawlPlanSaleReducer(state = initialState, action) {
  switch (action.type) {
    case actions.GET_LIST_API_PLAN_REQUEST:
      return {
        ...state,
        loading: true
      };
    case actions.GET_LIST_API_PLAN_SUCCESS:
      return {
        ...state,
        plans: action.plans,
        total: action.total,
        loading: false
      };
    case actions.GET_LIST_API_PLAN_ERROR:
      return {
        ...state,
        loading: false
      };
    case actions.GET_API_PLAN_DETAIL_REQUEST:
      return {
        ...state,
        plan: null
      }
    case actions.GET_API_PLAN_DETAIL_SUCCESS:
      return {
        ...state,
        plan: action.plan
      }
    case actions.GET_API_PLAN_DETAIL_ERROR:
      return {
        ...state,
        plan: null
      }
    case actions.ADD_API_PLAN_REQUEST:
      return {
        ...state
      }
    case actions.ADD_API_PLAN_SUCCESS:
      return {
        ...state,
        apiPlanId: action.apiPlanId
      }
    case actions.ADD_API_PLAN_ERROR:
      return {
        ...state
      }
    case actions.SYNC_DATA_PLAN_OTA_REQUEST:
      return {
        ...state,
        loading: true
      };
    case actions.SYNC_DATA_PLAN_OTA_SUCCESS:
      return {
        ...state,
        loading: false
      };
    case actions.SYNC_DATA_PLAN_OTA_ERROR:
      return {
        ...state,
        loading: false
      };
    case actions.GET_LIST_USER_REQUEST:
      return {
        ...state,
      };
    case actions.GET_LIST_USER_SUCCESS:
      return {
        ...state,
        listUser: action.listUser,
      };
    case actions.GET_LIST_USER_ERROR:
      return {
        ...state,
        error: action.error,
      };
    case actions.GET_SYNC_PLAN_STATUS_REQUEST:
      return {
        ...state,
        loadingSyncStatus: true,
      };
    case actions.GET_SYNC_PLAN_STATUS_SUCCESS:
      return {
        ...state,
        syncPlanStatus: action.syncPlanStatus,
        loadingSyncStatus: false,
      };
    case actions.GET_SYNC_PLAN_STATUS_ERROR:
      return {
        ...state,
        error: action.error,
        loadingSyncStatus: false,
      };
    case actions.UPDATE_DATA_PLAN_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case actions.UPDATE_DATA_PLAN_SUCCESS:
      return {
        ...state,
        loading: false,
      };
    case actions.UPDATE_DATA_PLAN_ERROR:
      return {
        ...state,
        loading: false,
        error: action.error,
      };
    case actions.CRAWL_ALL_PLAN_REQUEST:
      return {
        ...state,
        crawlAllLoading: true,
      };
    case actions.CRAWL_ALL_PLAN_SUCCESS:
      return {
        ...state,
        crawlAllLoading: false,
      };
    case actions.CRAWL_ALL_PLAN_ERROR:
      return {
        ...state,
        crawlAllLoading: false,
        error: action.error,
      };
    case actions.UPDATE_MULTIPLE_PLAN_REQUEST:
      return {
        ...state,
        uploadMultiple: true,
      };
    case actions.UPDATE_MULTIPLE_PLAN_SUCCESS:
      return {
        ...state,
        uploadMultiple: false,
      };
    case actions.UPDATE_MULTIPLE_PLAN_ERROR:
      return {
        ...state,
        uploadMultiple: false,
        error: action.error,
      };
    case actions.OPEN_SALE_PLAN_REQUEST:
      return {
        ...state,
        openSaleStatus: true,
      };
    case actions.OPEN_SALE_PLAN_SUCCESS:
      return {
        ...state,
        openSaleStatus: false,
      };
    case actions.OPEN_SALE_PLAN_ERROR:
      return {
        ...state,
        openSaleStatus: false,
        error: action.error,
      };

    case actions.STOP_SELLING_PLAN_REQUEST:
      return {
        ...state,
        stopSellingStatus: true,
      };
    case actions.STOP_SELLING_PLAN_SUCCESS:
      return {
        ...state,
        stopSellingStatus: false,
      };
    case actions.STOP_SELLING_PLAN_ERROR:
      return {
        ...state,
        stopSellingStatus: false,
        error: action.error,
      };
    case actions.RESET_API_PLAN_DETAIL_REQUEST:
      return {
        ...state,
        plan: null
      };
    case actions.GET_LIST_API_PLAN_LINK_PRICES_REQUEST:
      return {
        ...state
      };
    case actions.GET_LIST_API_PLAN_LINK_PRICES_SUCCESS:
      return {
        ...state,
        planLinkPrices: action.plans
      };
    case actions.GET_LIST_API_PLAN_LINK_PRICES_ERROR:
      return {
        ...state
      };
    default:
      return state;
  }
}
